import { helpers } from '@vuelidate/validators'

export default array =>
  helpers.withParams({ type: 'notInArray', array }, value => {
    if (!helpers.req(value)) return true
    return array.indexOf(value) === -1
  })
